<template>
  <div class="nx-nav-wrapper">
    <nav class="nx-nav" :class="{ 'nx-nav-scrolled': isScrolled }">
      <div class="nx-nav-container">
        <div class="nx-nav-logo">
          <img :src="config?.nav?.logo || '/img/logo.png'" alt="文信软件" @click="goHome" />
        </div>

        <!-- 汉堡菜单按钮 (仅移动端) -->
        <button class="nx-hamburger" :class="{ 'nx-hamburger-active': mobileMenuOpen }" @click="toggleMobileMenu">
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div class="nx-nav-menu">
        <a
          v-for="item in (config?.nav?.menu || [])"
          :key="item.index"
          :href="'#' + item.index"
          @click.prevent="handleMenuClick(item)"
          @mouseenter="handleMouseEnter(item)"
          @mouseleave="handleMouseLeave"
          class="nx-nav-link"
          :class="{ 'nx-nav-link-active': activeIndex === item.index, 'nx-nav-link-has-submenu': hasSubmenu(item) }"
        >
          <span class="nx-nav-link-text">{{ item.text }}</span>
          <i v-if="hasSubmenu(item)" class="el-icon-arrow-down nx-nav-arrow"></i>

          <!-- 下拉菜单 -->
          <transition name="nx-dropdown">
            <div
              v-if="hasSubmenu(item) && showSubmenu === item.text"
              class="nx-dropdown-menu"
              @mouseenter="keepSubmenu"
              @mouseleave="closeSubmenu"
            >
              <!-- 产品介绍 - 横向分类布局 -->
              <template v-if="item.text === '产品介绍'">
                <div class="nx-product-layout">
                  <!-- 超级智能体 - 上方独立区域 -->
                  <div class="nx-super-agent-banner" @click="goToSuperAgent">
                    <div class="nx-super-agent-content">
                      <span class="nx-super-agent-title">超级智能体</span>
                      <i class="el-icon-right nx-banner-enter-arrow"></i>
                    </div>
                  </div>

                  <!-- 高价值场景 - 上方独立区域 -->
                  <div class="nx-scenarios-banner" @click="goToScenarios">
                    <div class="nx-scenarios-content">
                      <span class="nx-scenarios-title">超级智能体·高价值场景</span>
                      <i class="el-icon-right nx-banner-enter-arrow"></i>
                    </div>
                  </div>

                  <!-- 各个分类的容器 -->
                  <div class="nx-product-categories">
                    <div
                      v-for="category in item.submenu"
                      :key="category.text"
                      class="nx-product-column"
                    >
                    <div class="nx-column-header">
                      <span v-if="category.icon" class="nx-column-icon">{{ category.icon }}</span>
                      <span class="nx-column-title">{{ category.text }}</span>
                    </div>
                    <div class="nx-column-items">
                      <a
                        v-for="product in category.items"
                        :key="product.text"
                        href="javascript:void(0)"
                        class="nx-column-item"
                        @click="openProductDetail(product, item.index)"
                      >
                        {{ product.text }}
                      </a>
                    </div>
                  </div>
                  </div>
                </div>
              </template>

              <!-- 普通菜单项（关于文信等） -->
              <template v-else>
                <div class="nx-simple-layout">
                  <a
                    v-for="subItem in item.submenu"
                    :key="subItem.text"
                    href="javascript:void(0)"
                    class="nx-simple-item"
                    @click="openInNewTab(subItem.path, item.index)"
                  >
                    {{ subItem.text }}
                  </a>
                </div>
              </template>
            </div>
          </transition>
        </a>
      </div>
      </div>
    </nav>

    <!-- 移动端菜单 (移到nav外部) -->
    <transition name="nx-mobile-menu">
      <div v-if="mobileMenuOpen" class="nx-mobile-menu-overlay" @click="closeMobileMenu">
        <div class="nx-mobile-menu-content" @click.stop>
          <div class="nx-mobile-menu-inner">
            <!-- 左侧一级菜单 -->
            <div class="nx-mobile-menu-left">
              <div class="nx-mobile-menu-header">
                <img :src="config?.nav?.logo || '/img/logo.png'" alt="文信软件" class="nx-mobile-logo" />
                <button class="nx-mobile-close" @click="closeMobileMenu">
                  <i class="el-icon-close"></i>
                </button>
              </div>
              <div class="nx-mobile-menu-list">
                <div
                  v-for="item in (config?.nav?.menu || [])"
                  :key="item.index"
                  class="nx-mobile-menu-item"
                  :class="{ 'nx-mobile-menu-item-active': activeMobileMenu === item.text }"
                  @click="selectMobileMenu(item)"
                >
                  <span class="nx-mobile-menu-text">{{ item.text }}</span>
                  <i v-if="hasSubmenu(item)" class="el-icon-arrow-right nx-mobile-menu-arrow"></i>
                </div>
              </div>
            </div>

            <!-- 右侧二级菜单 -->
            <transition name="nx-mobile-submenu">
              <div v-if="activeMobileMenuItem && hasSubmenu(activeMobileMenuItem)" class="nx-mobile-menu-right">
                <div class="nx-mobile-submenu-header">
                  <span>{{ activeMobileMenuItem.text }}</span>
                  <button class="nx-mobile-submenu-back" @click="backToMainMenu">
                    <i class="el-icon-arrow-left"></i>
                  </button>
                </div>

                <!-- 产品介绍 - 分类布局 -->
                <template v-if="activeMobileMenuItem.text === '产品介绍'">
                  <div class="nx-mobile-product-list">
                    <!-- 超级智能体 - 独立菜单项 -->
                    <div class="nx-mobile-super-agent-item" @click="goToSuperAgent">
                      <div class="nx-mobile-super-agent-content">
                        <span class="nx-mobile-super-agent-title">超级智能体</span>
                        <i class="el-icon-arrow-right nx-mobile-super-agent-arrow"></i>
                      </div>
                    </div>

                    <!-- 高价值场景 - 独立菜单项 -->
                    <div class="nx-mobile-scenarios-item" @click="goToScenarios">
                      <div class="nx-mobile-scenarios-content">
                        <span class="nx-mobile-scenarios-title">超级智能体·高价值场景</span>
                        <i class="el-icon-arrow-right nx-mobile-scenarios-arrow"></i>
                      </div>
                    </div>

                    <!-- 各个分类 -->
                    <div
                      v-for="category in activeMobileMenuItem.submenu"
                      :key="category.text"
                      class="nx-mobile-product-category"
                    >
                      <div class="nx-mobile-category-header">
                        <span v-if="category.icon" class="nx-mobile-category-icon">{{ category.icon }}</span>
                        <span class="nx-mobile-category-title">{{ category.text }}</span>
                      </div>
                      <div class="nx-mobile-category-items">
                        <a
                          v-for="product in category.items"
                          :key="product.text"
                          class="nx-mobile-category-item"
                          @click="openProductDetail(product, activeMobileMenuItem.index)"
                        >
                          {{ product.text }}
                        </a>
                      </div>
                    </div>
                  </div>
                </template>

                <!-- 普通菜单项 -->
                <template v-else>
                  <div class="nx-mobile-simple-list">
                    <a
                      v-for="subItem in activeMobileMenuItem.submenu"
                      :key="subItem.text"
                      class="nx-mobile-simple-item"
                      @click="openInNewTab(subItem.path, activeMobileMenuItem.index)"
                    >
                      {{ subItem.text }}
                    </a>
                  </div>
                </template>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'NxNav',
  props: {
    config: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      activeIndex: '1',
      isScrolled: false,
      scrollRAF: null,
      sectionOffsets: {},
      isScrolling: false,
      resizeTimeout: null,
      showSubmenu: null,
      submenuTimer: null,
      mobileMenuOpen: false,
      activeMobileMenu: null,
      activeMobileMenuItem: null
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleResize, { passive: true });

    // 缓存板块位置
    this.cacheSectionOffsets();

    // 根据当前路由设置active状态
    this.updateActiveByRoute();

    // 等待DOM完全加载后初始化active状态
    this.$nextTick(() => {
      requestAnimationFrame(() => {
        this.handleScroll();
      });
    });
  },
  watch: {
    '$route'(to, from) {
      // 只有在路由真正变化时才更新
      if (to.path !== from.path) {
        this.updateActiveByRoute();
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);

    // 取消待执行的 RAF
    if (this.scrollRAF) {
      cancelAnimationFrame(this.scrollRAF);
    }

    // 清除下拉菜单定时器
    if (this.submenuTimer) {
      clearTimeout(this.submenuTimer);
    }
  },
  methods: {
    updateActiveByRoute() {
      const path = this.$route.path;

      // 根据路由设置高亮菜单
      // 只有在非首页时才根据路由设置高亮
      if (path !== '/') {
        if (path.includes('/product-detail')) {
          this.activeIndex = '3'; // 产品介绍
        } else if (path.includes('/classic-cases') || path.includes('/customer-list') || path.includes('/services')) {
          this.activeIndex = '4'; // 客户案例
        } else if (path.includes('/news-center') || path.includes('/news-detail') || path.includes('/qualifications')) {
          this.activeIndex = '2'; // 关于文信
        } else if (path.includes('/contact-us')) {
          this.activeIndex = '6'; // 联系我们
        }
      }
    },
    hasSubmenu(item) {
      return item.submenu && item.submenu.length > 0;
    },
    handleMenuClick(item) {
      // 点击时设置高亮
      this.activeIndex = item.index;

      // 如果有二级菜单，不执行滚动
      if (this.hasSubmenu(item)) {
        return;
      }
      this.scrollTo(item.scrollTo);
    },
    handleMouseEnter(item) {
      if (this.hasSubmenu(item)) {
        if (this.submenuTimer) {
          clearTimeout(this.submenuTimer);
        }
        this.showSubmenu = item.text;
      }
    },
    handleMouseLeave() {
      if (this.submenuTimer) {
        clearTimeout(this.submenuTimer);
      }
      this.submenuTimer = setTimeout(() => {
        this.showSubmenu = null;
      }, 100);
    },
    keepSubmenu() {
      if (this.submenuTimer) {
        clearTimeout(this.submenuTimer);
      }
    },
    closeSubmenu() {
      this.showSubmenu = null;
    },
    openInNewTab(path, parentIndex) {
      this.closeSubmenu();
      // 高亮父级菜单
      if (parentIndex) {
        this.activeIndex = parentIndex;
      }
      const url = window.location.origin + path;
      window.open(url, '_blank', 'noopener,noreferrer');
    },
    openProductDetail(productItem, parentIndex) {
      this.closeSubmenu();
      // 高亮父级菜单
      if (parentIndex) {
        this.activeIndex = parentIndex;
      }
      // 在新标签页打开产品详情页
      const params = new URLSearchParams({
        category: productItem.categoryName,
        product: productItem.text,
        index: productItem.productId
      });
      const url = window.location.origin + '/product-detail?' + params.toString();
      window.open(url, '_blank', 'noopener,noreferrer');
    },
    goToSuperAgent() {
      this.closeSubmenu();
      // 在新标签页打开超级智能体详情页
      window.open('/super-agent', '_blank');
    },
    goToScenarios() {
      this.closeSubmenu();
      // 在新标签页打开高价值场景列表页
      window.open('/scenarios', '_blank');
    },
    goHome() {
      this.$router.push('/').then(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    cacheSectionOffsets() {
      const sections = ['home', 'about', 'products', 'cases', 'solutions', 'contact'];
      sections.forEach(section => {
        const element = document.getElementById(section);
        if (element) {
          this.sectionOffsets[section] = element.offsetTop;
        }
      });
    },
    scrollTo(position) {
      // 检查是否在首页
      if (this.$route.path !== '/') {
        this.$router.push('/').then(() => {
          setTimeout(() => {
            this.scrollToPosition(position);
          }, 300);
        });
        return;
      }
      this.scrollToPosition(position);
    },
    scrollToPosition(position) {
      // 暂时禁用滚动监听中的activeIndex更新
      this.isScrolling = true;

      // 直接根据 menu item 的 index 获取对应的 section ID
      const sections = ['home', 'about', 'products', 'cases', 'solutions', 'contact'];
      const menuItem = this.config?.nav?.menu?.find(item => item.scrollTo === position);
      const targetIndex = menuItem ? parseInt(menuItem.index) - 1 : 0;
      const targetId = sections[targetIndex] || 'home';

      // 立即更新activeIndex
      this.activeIndex = String(targetIndex + 1);

      if (targetId === 'home') {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      } else {
        const element = document.getElementById(targetId);
        if (element) {
          const navHeight = 30;
          const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - navHeight;

          window.scrollTo({
            top: offsetPosition,
            left: 0,
            behavior: 'smooth'
          });
        }
      }

      // 等待滚动完成后重新启用监听
      setTimeout(() => {
        this.isScrolling = false;
      }, 1000);
    },
    handleResize() {
      // 防抖处理 resize
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }
      this.resizeTimeout = setTimeout(() => {
        this.cacheSectionOffsets();
      }, 150);
    },
    handleScroll() {
      // 使用 requestAnimationFrame 优化滚动性能
      if (this.scrollRAF) {
        return;
      }

      this.scrollRAF = requestAnimationFrame(() => {
        this.scrollRAF = null;

        this.isScrolled = window.scrollY > 100;
      });
    },
    // 移动端菜单方法
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
      if (this.mobileMenuOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
      this.activeMobileMenu = null;
      this.activeMobileMenuItem = null;
      document.body.style.overflow = '';
    },
    selectMobileMenu(item) {
      this.activeMobileMenu = item.text;
      this.activeMobileMenuItem = item;

      // 如果没有二级菜单，直接跳转
      if (!this.hasSubmenu(item)) {
        this.handleMenuClick(item);
        this.closeMobileMenu();
      }
    },
    backToMainMenu() {
      this.activeMobileMenu = null;
      this.activeMobileMenuItem = null;
    }
  }
};
</script>

<style scoped>
.nx-nav-wrapper {
  position: relative;
}

.nx-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(25, 118, 210, 0.2);
  transition: var(--nx-transition-luxury);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  will-change: transform;

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg,
      transparent 0%,
      rgba(25, 118, 210, 0.3) 50%,
      transparent 100%);
    opacity: 0.6;
  }
}

.nx-nav-scrolled {
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.15);
  border-bottom-color: rgba(25, 118, 210, 0.3);
}

.nx-nav-container {
  width: 100%;
  padding: 0 40px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

.nx-nav-logo {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.nx-nav-logo img {
  height: 38px;
  transition: var(--nx-transition-luxury);
  filter: none;
  will-change: transform, filter;
}

.nx-nav-logo:hover img {
  filter: drop-shadow(0 4px 12px rgba(25, 118, 210, 0.3));
  transform: scale(1.05);
}

.nx-nav-menu {
  display: flex;
  gap: 30px;
  margin-left: auto;
}

.nx-nav-link {
  position: relative;
  padding: 0;
  color: #3d3d3d;
  text-decoration: none;
  font-size: 15px;
  font-weight: 500;
  transition: var(--nx-transition-smooth);
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.nx-nav-link-text {
  position: relative;
  z-index: 1;
}

.nx-nav-arrow {
  font-size: 12px;
  transition: transform 0.3s ease;
}

.nx-nav-link-has-submenu:hover .nx-nav-arrow {
  transform: rotate(180deg);
}

.nx-nav-link:hover {
  color: var(--nx-blue-primary);
  text-shadow: none;
}

.nx-nav-link-active {
  color: var(--nx-blue-primary);
  text-shadow: none;
  font-weight: 600;
}

/* 下拉菜单 */
.nx-dropdown-menu {
  position: fixed;
  top: 70px;
  left: 0;
  right: 0;
  background: white;
  border-radius: 0;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  padding: 15px 0;
  z-index: 1001;
}

/* 产品介绍 - 横向布局 */
.nx-product-layout {
  display: flex;
  flex-direction: column;
  padding: 30px 60px;
  max-width: 1600px;
  margin: 0 auto;
}

.nx-product-categories {
  display: flex;
  justify-content: center;
  gap: 50px;
}

.nx-product-column {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 160px;
  border-right: 1px solid rgba(25, 118, 210, 0.1);
  padding-right: 50px;
}

.nx-product-column:last-child {
  border-right: none;
  padding-right: 0;
}

/* 超级智能体 - 上方横排区域 */
.nx-super-agent-banner {
  grid-column: 1 / -1;
  padding: 15px 30px;
  background: linear-gradient(135deg, rgba(255, 107, 107, 0.1) 0%, rgba(254, 202, 87, 0.1) 100%);
  border-radius: 12px;
  margin-bottom: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.nx-super-agent-banner:hover {
  background: linear-gradient(135deg, rgba(255, 107, 107, 0.15) 0%, rgba(254, 202, 87, 0.15) 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.2);
}

.nx-super-agent-content {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
}

.nx-super-agent-title {
  font-size: 18px;
  font-weight: 700;
  color: #1976d2;
}

/* 横幅文字后的进入标识 */
.nx-banner-enter-arrow {
  font-size: 16px;
  color: #1976d2;
  transition: transform 0.3s ease;
}

.nx-super-agent-banner:hover .nx-banner-enter-arrow,
.nx-scenarios-banner:hover .nx-banner-enter-arrow {
  transform: translateX(4px);
}

/* 高价值场景 - 上方横排区域（与超级智能体同构，蓝色主题） */
.nx-scenarios-banner {
  padding: 15px 30px;
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.1) 0%, rgba(0, 188, 212, 0.1) 100%);
  border-radius: 12px;
  margin-bottom: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.nx-scenarios-banner:hover {
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.15) 0%, rgba(0, 188, 212, 0.15) 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(25, 118, 210, 0.2);
}

.nx-scenarios-content {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
}

.nx-scenarios-title {
  font-size: 18px;
  font-weight: 700;
  color: #1976d2;
}


.nx-column-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.3);
}

.nx-column-icon {
  font-size: 18px;
}

.nx-column-title {
  font-size: 16px;
  font-weight: 700;
  color: #1565c0;
}

.nx-column-items {
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: center;
}

.nx-column-item {
  padding: 8px 12px;
  color: #424242;
  text-decoration: none;
  font-size: 14px;
  border-radius: 6px;
  transition: all 0.2s ease;
  cursor: pointer;
  white-space: nowrap;
  text-align: center;
}

.nx-column-item:hover {
  background: #f0f7ff;
  color: #1976d2;
}

/* 普通菜单项 */
.nx-simple-layout {
  display: flex;
  justify-content: center;
  gap: 60px;
  padding: 20px 60px;
}

.nx-simple-item {
  padding: 12px 30px;
  color: #3d3d3d;
  text-decoration: none;
  font-size: 14px;
  transition: all 0.3s ease;
  cursor: pointer;
  white-space: nowrap;
  border-radius: 8px;
}

.nx-simple-item:hover {
  background: #f0f7ff;
  color: #1976d2;
}

/* 动画 */
.nx-dropdown-enter-active,
.nx-dropdown-leave-active {
  transition: all 0.3s ease;
}

.nx-dropdown-enter,
.nx-dropdown-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

@media (max-width: 768px) {
  .nx-nav-container {
    padding: 0 20px;
    justify-content: flex-start;
  }

  .nx-nav-menu {
    display: none;
  }

  .nx-nav-link {
    font-size: 14px;
  }
}

@media (max-width: 1024px) and (min-width: 769px) {
  .nx-nav-menu {
    gap: 20px;
  }

  .nx-nav-link {
    font-size: 14px;
  }

  .nx-product-layout {
    gap: 20px;
    padding: 15px 20px;
    min-width: 600px;
  }

  .nx-product-column {
    min-width: 100px;
    padding-right: 20px;
  }

  .nx-column-title {
    font-size: 14px;
  }

  .nx-column-item {
    font-size: 13px;
    padding: 6px 10px;
  }
}

/* ==================== 移动端菜单样式 ==================== */

/* 汉堡菜单按钮 */
.nx-hamburger {
  display: none;
  flex-direction: column;
  justify-content: space-around;
  width: 28px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10001;
  margin-left: auto;
}

.nx-hamburger span {
  width: 100%;
  height: 2.5px;
  background: #1976d2;
  border-radius: 2px;
  transition: all 0.3s ease;
  transform-origin: center;
}

.nx-hamburger-active span:nth-child(1) {
  transform: translateY(10.5px) rotate(45deg);
}

.nx-hamburger-active span:nth-child(2) {
  opacity: 0;
}

.nx-hamburger-active span:nth-child(3) {
  transform: translateY(-10.5px) rotate(-45deg);
}

/* 移动端菜单遮罩层 */
.nx-mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

.nx-mobile-menu-content {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 85%;
  max-width: 400px;
  background: #fff;
  box-shadow: -5px 0 30px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  z-index: 10000;
}

.nx-mobile-menu-inner {
  display: flex;
  height: 100%;
  position: relative;
}

/* 左侧一级菜单 */
.nx-mobile-menu-left {
  width: 100%;
  flex-shrink: 0;
  transition: transform 0.3s ease;
  background: #f8f9fa;
}

.nx-mobile-menu-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  background: #fff;
  border-bottom: 1px solid rgba(25, 118, 210, 0.1);
}

.nx-mobile-logo {
  height: 32px;
}

.nx-mobile-close {
  width: 32px;
  height: 32px;
  border: none;
  background: #f0f7ff;
  border-radius: 50%;
  color: #1976d2;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.nx-mobile-close:hover {
  background: #1976d2;
  color: #fff;
}

.nx-mobile-menu-list {
  padding: 10px 0;
  overflow-y: auto;
  height: calc(100% - 62px);
}

.nx-mobile-menu-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  color: #3d3d3d;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-left: 3px solid transparent;
}

.nx-mobile-menu-item:active {
  background: #e3f2fd;
}

.nx-mobile-menu-item-active {
  background: #fff;
  color: #1976d2;
  font-weight: 600;
  border-left-color: #1976d2;
}

.nx-mobile-menu-arrow {
  font-size: 14px;
  color: #90a4ae;
}

.nx-mobile-menu-item-active .nx-mobile-menu-arrow {
  color: #1976d2;
}

/* 右侧二级菜单 */
.nx-mobile-menu-right {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  overflow-y: auto;
}

.nx-mobile-submenu-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  background: #1976d2;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 10;
}

.nx-mobile-submenu-back {
  width: 32px;
  height: 32px;
  border: none;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.nx-mobile-submenu-back:active {
  background: rgba(255, 255, 255, 0.3);
}

/* 移动端产品列表 */
.nx-mobile-product-list {
  padding: 15px;
}

/* 移动端超级智能体菜单项 */
.nx-mobile-super-agent-item {
  background: linear-gradient(135deg, rgba(255, 107, 107, 0.1) 0%, rgba(254, 202, 87, 0.1) 100%);
  border-radius: 12px;
  padding: 15px 20px;
  margin-bottom: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 107, 107, 0.2);
}

.nx-mobile-super-agent-item:active {
  background: linear-gradient(135deg, rgba(255, 107, 107, 0.15) 0%, rgba(254, 202, 87, 0.15) 100%);
  transform: scale(0.98);
}

.nx-mobile-super-agent-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.nx-mobile-super-agent-title {
  flex: 1;
  font-size: 16px;
  font-weight: 700;
  color: #1976d2;
}

.nx-mobile-super-agent-arrow {
  color: #1976d2;
  font-size: 18px;
}

/* 移动端高价值场景菜单项（与超级智能体同构，蓝色主题） */
.nx-mobile-scenarios-item {
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.1) 0%, rgba(0, 188, 212, 0.1) 100%);
  border-radius: 12px;
  padding: 15px 20px;
  margin-bottom: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid rgba(25, 118, 210, 0.2);
}

.nx-mobile-scenarios-item:active {
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.15) 0%, rgba(0, 188, 212, 0.15) 100%);
  transform: scale(0.98);
}

.nx-mobile-scenarios-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.nx-mobile-scenarios-title {
  flex: 1;
  font-size: 16px;
  font-weight: 700;
  color: #1976d2;
}

.nx-mobile-scenarios-arrow {
  color: #1976d2;
  font-size: 18px;
}

.nx-mobile-product-category {
  margin-bottom: 20px;
}

.nx-mobile-product-category:last-child {
  margin-bottom: 0;
}

.nx-mobile-category-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 15px;
  background: linear-gradient(135deg, #e3f2fd 0%, #f0f7ff 100%);
  border-radius: 10px;
  margin-bottom: 10px;
}

.nx-mobile-category-icon {
  font-size: 18px;
}

.nx-mobile-category-title {
  font-size: 15px;
  font-weight: 600;
  color: #1565c0;
}

.nx-mobile-category-items {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding-left: 10px;
}

.nx-mobile-category-item {
  padding: 12px 18px;
  color: #424242;
  font-size: 14px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.nx-mobile-category-item:active {
  background: #f0f7ff;
  color: #1976d2;
}

/* 移动端普通菜单 */
.nx-mobile-simple-list {
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.nx-mobile-simple-item {
  padding: 14px 20px;
  color: #3d3d3d;
  font-size: 15px;
  background: #f8f9fa;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.nx-mobile-simple-item:active {
  background: #e3f2fd;
  color: #1976d2;
}

/* 移动端菜单动画 */
.nx-mobile-menu-enter-active,
.nx-mobile-menu-leave-active {
  transition: opacity 0.3s ease;
}

.nx-mobile-menu-enter-active .nx-mobile-menu-content,
.nx-mobile-menu-leave-active .nx-mobile-menu-content {
  transition: transform 0.3s ease;
}

.nx-mobile-menu-enter,
.nx-mobile-menu-leave-to {
  opacity: 0;
}

.nx-mobile-menu-enter .nx-mobile-menu-content,
.nx-mobile-menu-leave-to .nx-mobile-menu-content {
  transform: translateX(100%);
}

.nx-mobile-submenu-enter-active,
.nx-mobile-submenu-leave-active {
  transition: all 0.3s ease;
}

.nx-mobile-submenu-enter,
.nx-mobile-submenu-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

@media (max-width: 768px) {
  .nx-hamburger {
    display: flex;
  }

  .nx-nav-container {
    padding: 0 15px;
  }
}
</style>
